import React, { memo, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, IconButton, Typography } from '@mui/material';
import { CallEndIcon } from '@sharedCR/coreDesignSystem/icons';

import { TelnyxCallState } from 'constants/telephony';

import { hangupCallAction } from 'store/system/actions';
import { selectCallState } from 'store/system/selectors';

import {
  callerInfoStyles,
  containerStyles,
  destinationNumberStyles,
  hangupButtonStyles,
  statusTextStyles,
} from './OutgoingCall.styles';
import { OutgoingCallTestIds } from './OutgoingCall.testIds';

const OutgoingCall = () => {
  const dispatch = useDispatch();
  const callState = useSelector(selectCallState);

  const onHangup = useCallback(() => {
    dispatch(hangupCallAction());
  }, [dispatch]);

  const { dialedNumber, telnyxCallState } = callState;
  const displayNumber = dialedNumber || 'Unknown';

  const statusLabel = useMemo(() => {
    if (telnyxCallState === TelnyxCallState.EARLY) {
      return 'Ringing...';
    }

    if (telnyxCallState === TelnyxCallState.ACTIVE) {
      return 'Connected';
    }

    return 'Calling...';
  }, [telnyxCallState]);

  return (
    <Box sx={containerStyles}>
      <Box sx={callerInfoStyles}>
        <Typography sx={destinationNumberStyles} variant="bold20">
          {displayNumber}
        </Typography>
        <Typography sx={statusTextStyles} variant="regular14">
          {statusLabel}
        </Typography>
      </Box>

      <IconButton
        aria-label="Hang up"
        data-testid={OutgoingCallTestIds.HANGUP}
        sx={hangupButtonStyles}
        onClick={onHangup}
      >
        <CallEndIcon />
      </IconButton>
    </Box>
  );
};

export default memo(OutgoingCall);
